<template>
  <img
    v-if="hasLogo"
    class="v-toolbar-logo"
    :src="logoUrl"
    :style="{
      height: styles.height
    }"
  />
  <div v-else :class="['v-toolbar__text', { '--white': isWhiteTextColor }]">
    {{ fallbackText }}
  </div>
</template>

<script>
import { mapState } from "vuex"
import { isPresent, getImageUrl } from "@/lib/utils"
import { isDarkTextColor } from "@shared/determine-text-color"

export const DEFAULT_STYLES = { height: "50%" }

export default {
  props: {
    logo: { type: Object, default: () => ({}) },
    fallbackText: { type: String, default: "" },
    styles: { type: Object, default: () => DEFAULT_STYLES }
  },

  computed: {
    ...mapState(["global"]),

    hasLogo() {
      return isPresent(this.logo)
    },

    toolbarBackgroundColor() {
      return this.global?.toolbar?.background_color
    },

    logoUrl() {
      return getImageUrl(this.logo)
    },

    isWhiteTextColor() {
      if (this.hasLogo) return false

      return this.toolbarBackgroundColor
        ? !isDarkTextColor(this.toolbarBackgroundColor)
        : false
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables";

.v-toolbar-logo {
  max-height: 100%;
  max-width: 208px;
  align-self: center;
  max-height: $toolbar--height;
  min-width: 0;
  flex-shrink: 1;
  object-fit: contain;
}

.v-toolbar__text.--white {
  color: $color-ui--white;
}
</style>
